import React from 'react'
import PropTypes from 'prop-types'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'

const FieldConfigShape = PropTypes.shape({
  accessor: PropTypes.string,
  prefix: PropTypes.string,
  format: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
})

function NodeImage ({ src, alt }) {
  if (!src) return null
  return (
    <img
      src={src}
      alt={alt || ''}
      style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0
      }}
    />
  )
}

NodeImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string
}

function NodeField ({ value, config, variantColor, baseStyle }) {
  const { formatter } = useFormattingContext()
  if (value == null) return null

  const displayValue = config?.format
    ? formatter(value, config.format)
    : value

  const mergedStyle = {
    ...baseStyle,
    color: variantColor || 'inherit',
    ...(config?.style || {})
  }

  return (
    <div className={config?.className || ''} style={mergedStyle}>
      {displayValue}
    </div>
  )
}

NodeField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  config: FieldConfigShape,
  variantColor: PropTypes.string,
  baseStyle: PropTypes.object
}

const NAME_STYLE = {
  fontWeight: 600,
  lineHeight: 1.3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'center'
}

const DESCRIPTION_STYLE = {
  fontSize: '0.8125em',
  opacity: 0.85,
  marginTop: 2,
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

export default function NodeContent ({ nameValue, nameConfig, descriptionValue, descriptionConfig, image, variantColor }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
      <NodeImage src={image} alt={typeof nameValue === 'string' ? nameValue : ''} />
      <div style={{ minWidth: 0, flex: image ? 1 : undefined }}>
        <NodeField
          value={nameValue}
          config={nameConfig}
          variantColor={variantColor}
          baseStyle={NAME_STYLE}
        />
        <NodeField
          value={descriptionValue}
          config={descriptionConfig}
          variantColor={variantColor}
          baseStyle={DESCRIPTION_STYLE}
        />
      </div>
    </div>
  )
}

NodeContent.propTypes = {
  nameValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nameConfig: FieldConfigShape,
  descriptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  descriptionConfig: FieldConfigShape,
  image: PropTypes.string,
  variantColor: PropTypes.string
}
